import type { DashboardPanelProps, DashboardStatCardProps } from './billingDashboardTypes';

export function DashboardPanel({
  title,
  description,
  children,
  isDark,
  actions,
}: DashboardPanelProps) {
  return (
    <div className={`overflow-hidden rounded-2xl border ${isDark ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-white'}`}>
      <div className={`flex flex-col gap-3 border-b px-4 py-3 md:flex-row md:items-center md:justify-between ${isDark ? 'border-gray-800 bg-gray-900/90' : 'border-gray-200 bg-gray-50/80'}`}>
        <div>
          <div className={`text-[11px] font-semibold uppercase tracking-[0.18em] ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
            {title}
          </div>
          {description ? (
            <p className={`mt-0.5 text-[13px] ${isDark ? 'text-gray-300' : 'text-gray-600'}`}>
              {description}
            </p>
          ) : null}
        </div>

        {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
      </div>

      {children}
    </div>
  );
}

export function DashboardStatCard({
  label,
  value,
  detail,
  icon: Icon,
  isDark,
  accentColor,
  valueClassName,
}: DashboardStatCardProps) {
  return (
    <div className={`rounded-xl border px-4 py-3 ${isDark ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-white'}`}>
      <div className="flex items-center gap-2">
        <div className={`rounded-lg p-2 ${isDark ? 'bg-gray-800 text-gray-200' : 'bg-gray-50 text-gray-700 border border-gray-200'}`}>
          <Icon className="h-4 w-4" style={{ color: accentColor }} />
        </div>
        <div className={`text-[11px] font-semibold uppercase tracking-[0.16em] ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
          {label}
        </div>
      </div>
      <div className={`mt-2 text-xl font-semibold tracking-tight ${valueClassName || (isDark ? 'text-white' : 'text-gray-900')}`}>
        {value}
      </div>
      {detail ? (
        <div className={`mt-1 text-[11px] ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
          {detail}
        </div>
      ) : null}
    </div>
  );
}
